module.exports = __webpack_public_path__ + "img/marmelaedchen-essig_xs.6f52d080.jpg";